// extracted by mini-css-extract-plugin
export var buttonWrapper = "BrochureCard-module--button-wrapper--57cfc";
export var card = "BrochureCard-module--card--cf4c7";
export var cardContent = "BrochureCard-module--card-content--eb6d9";
export var contentContainer = "BrochureCard-module--content-container--493c5";
export var cta = "BrochureCard-module--cta--a62b2";
export var description = "BrochureCard-module--description--d94b1";
export var horizontal = "BrochureCard-module--horizontal--ecbfa";
export var imageContainer = "BrochureCard-module--image-container--57be6";
export var imageHorizontal = "BrochureCard-module--image-horizontal--57619";
export var infoContainer = "BrochureCard-module--info-container--db9bc";
export var subtitle = "BrochureCard-module--subtitle--34949";
export var title = "BrochureCard-module--title--db68d";